<template>
  <div class="home">
    <!-- header_fxed -->
    <Header :router_url="router_url"></Header>
    <!-- header_fxed end -->
    <!-- 跳转到app -->
    <div class="app_tag _width">
      <img
        src="@/assets/image/header/logo.png"
        alt=""
      />
      <button @click="openapp">下载APP</button>
    </div>
    <!-- 跳转到app end-->

    <div class="conter_wp">
      <!-- 分享 -->
      <div class="wrap share_wp">
        <div class="share_wp_cp _width">
          <div class="flex_share">
            <div v-if="
                details.count !== 0 &&
                details.count !== null &&
                details.count !== ''
              ">
              <a
                href="javascript:;"
                @click="follow()"
                v-if="is_follow == false"
                @mouseenter="shareicon = 1"
                @mouseleave="shareicon = 0"
              >
                <img
                  src="@/assets/image/share/follow1.png"
                  alt=""
                />
                <img
                  src="@/assets/image/share/follow2.png"
                  alt=""
                  class="hide_tab"
                  :class="shareicon == 1 ? 'show_icon' : ''"
                />
              </a>

              <a
                href="javascript:;"
                @click="follow()"
                v-if="is_follow == true"
              >
                <img
                  src="@/assets/image/share/follow2.png"
                  alt=""
                />
              </a>
            </div>

            <a
              href="javascript:;"
              @click="share_wb"
              @mouseenter="shareicon = 2"
              @mouseleave="shareicon = 0"
            >
              <img
                src="@/assets/image/share/wb1.png"
                alt=""
              />
              <img
                src="@/assets/image/share/wb2.png"
                alt=""
                class="hide_tab"
                :class="shareicon == 2 ? 'show_icon' : ''"
              />
            </a>

            <a
              href="javascript:;"
              @click="share_qq"
              @mouseenter="shareicon = 3"
              @mouseleave="shareicon = 0"
            >
              <img
                src="@/assets/image/share/qq1.png"
                alt=""
              />
              <img
                src="@/assets/image/share/qq2.png"
                alt=""
                class="hide_tab"
                :class="shareicon == 3 ? 'show_icon' : ''"
              />
            </a>

            <a
              href="javascript:;"
              @click="share_qz"
              @mouseenter="shareicon = 4"
              @mouseleave="shareicon = 0"
            >
              <img
                src="@/assets/image/share/kj1.png"
                alt=""
              />
              <img
                src="@/assets/image/share/kj2.png"
                alt=""
                class="hide_tab"
                :class="shareicon == 4 ? 'show_icon' : ''"
              />
            </a>

            <a
              href="javascript:;"
              style="overflow: inherit"
              @mouseenter="shareicon = 5"
              @mouseleave="shareicon = 0"
            >
              <img
                src="@/assets/image/share/wx1.png"
                alt=""
                class="icons"
              />
              <img
                src="@/assets/image/share/wx2.png"
                alt=""
                class="hide_tab icons"
                :class="shareicon == 5 ? 'show_icon' : ''"
              />

              <!-- 微信code -->
              <div
                class="wx_code"
                :class="shareicon == 5 ? 'show_code' : ''"
              >
                <div>
                  <div
                    class="wecodeSp"
                    id="qrcodes"
                    ref="qrcodeContainers"
                  ></div>
                  <span></span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- 分享 -->

      <div
        class="banner_wp _width"
        id="banner_wp"
      >
        <!-- 居中 -->
        <div class="wrap">
          <!-- 活动详情的 banner -->
          <div
            class="avtivity_banenr"
            v-if="!details_son"
          >
            <div class="error_img">
              <div class="error_img_conter fade_image_out">
                <img
                  :src="error_login"
                  class="fade_image_out"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div
            class="avtivity_banenr"
            v-if="details_son"
          >
            <img
              :src="details_son.activityUrl | filterFun_as"
              alt=""
              class="fade_image_out covs"
              v-if="details_son.activityUrl"
            />

            <div class="mose"></div>
            <!-- 封面信息 -->
            <div class="cover_tips">
              <!-- 截止日期 -->
              <button
                class="end_time"
                v-if="details.count !== 0"
              >
                距截稿<span>{{ details.count }}</span>天
              </button>

              <!-- 截止日期 end-->
              <!-- 隐藏活动相关信息 -->
              <p
                class="_width title"
                style="display: none"
              >
                {{ details_son.title }}
              </p>

              <!-- 线 -->
              <div
                class="border _width"
                style="display: none"
              >
                <span></span>
                <i></i>
                <span></span>
              </div>
              <!-- 线 -->

              <p
                v-html="details_son.organizer"
                class="_width dw activity-text-style"
                style="display: none"
              ></p>
              <!-- <p class="_width dw">主办：{{details_son.organizer}}</p> -->
              <p
                class="_width dw activity-text-style"
                style="display: none"
              >
                活动时间：{{ details_son.dealOpenTime }}至{{
                  details_son.dealEndTime
                }}
              </p>

              <!-- 活动未开始 -->
              <button
                class="compete_now end_time_btn"
                v-if="details_son.status == 3 && details.activityStatus == 1"
                disabled="disabled"
              >
                即将开始,敬请期待
              </button>

              <div v-if="details_son.status == 3 && details.activityStatus == 2">
                <!-- pc -->
                <button
                  class="compete_now pc_show"
                  v-ripple="'rgba(255, 255, 255, 0.25)'"
                  @click="
                    on_click_go(details_son.id, details_son.title, details_son)
                  "
                >
                  立即参赛
                </button>
                <!-- 移动 -->
                <button
                  class="compete_now mb_show"
                  v-ripple="'rgba(255, 255, 255, 0.25)'"
                  @click="openapp()"
                >
                  立即参赛
                </button>
              </div>

              <!-- 活动结束 -->
              <button
                class="compete_now end_time_btn"
                v-if="details_son.status == 5"
                disabled="disabled"
              >
                活动结束
              </button>
            </div>
            <!-- 封面信息 -->
          </div>
          <!-- 活动详情的 banner -->
        </div>
        <!-- 居中 -->

        <!-- tab -->
        <div class="_width tab">
          <div class="risk-tab-top">
            <!-- <div class="risk-tab-cont"
               @click="tabChange(item.name)"
               v-for="(item,index2) in tabList "
               :class="[activeIndex == item.name?'risk-active':'']"
               :key="index2">{{item.name}}
            <div class="risk-active-line"
                 :class="[activeIndex==item.name ? 'show' : '' ]"></div>
          </div> -->

            <div
              class="risk-tab-cont"
              v-if="gs_show == true"
              @click="tabChange('获奖公示')"
              :class="[activeIndex == '获奖公示' ? 'risk-active' : '']"
            >
              获奖公示
              <div
                class="risk-active-line"
                :class="[activeIndex == '获奖公示' ? 'show' : '']"
              ></div>
            </div>
            <div
              v-if="activityId !== 'd084456319e24d7e85ee15e668e04678'"
              class=""
              style="display: flex; height: 100%"
            >
              <div
                class="risk-tab-cont"
                v-if="zp_show == true"
                @click="tabChange('全部作品')"
                :class="[activeIndex == '全部作品' ? 'risk-active' : '']"
              >
                全部作品
                <div
                  class="risk-active-line"
                  :class="[activeIndex == '全部作品' ? 'show' : '']"
                ></div>
              </div>

              <div
                class="risk-tab-cont"
                v-if="hd_show == true"
                @click="tabChange('活动简介')"
                :class="[activeIndex == '活动简介' ? 'risk-active' : '']"
              >
                活动简介
                <div
                  class="risk-active-line"
                  :class="[activeIndex == '活动简介' ? 'show' : '']"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <!-- tab end-->
      </div>
      <!-- banner_wp end -->

      <!-- 居中 -->
      <div
        class="wrap"
        style="z-index: 40"
      >
        <ul class="risk-cont _width">
          <!-- 获奖公示 -->
          <li v-if="details_son.publicityStatus == 1 && activeIndex == '获奖公示'">
            <div class="pad _width">
              <Loading :loading_bool="loading_bool"></Loading>
              <!-- 公示模板 1轮播图模式；2平铺模式 -->

              <!-- 1轮播图模式 -->
              <div v-if="
                  !loading_bool &&
                  Publicity &&
                  this.details_son.publicityTemplate == 1
                ">
                <!-- 公示简介 -->
                <div
                  class="introduction works_dosc"
                  v-if="details_son.publicityContent"
                  v-html="details_son.publicityContent"
                ></div>

                <!-- 移动端获奖作品 -->
                <div
                  class="mobile_works _width fl anmition_show"
                  v-for="(item_jx, index_jx) in Publicity"
                  :key="index_jx"
                  :class="{'add-height':index_jx == 0}"
                >
                  <!-- 获奖icon -->
                  <div
                    class="winning_icon _width"
                    v-if="item_jx.prizeName"
                  >
                    <div class="winning_icon_img">
                      <img
                        src="@/assets/image/avtivity_details/winning.png"
                        alt=""
                      />
                      <p>{{ item_jx.prizeName }}</p>
                    </div>
                  </div>

                  <div
                    class="winning_works _width winning_works_mobile"
                    v-for="(item_m, i) in item_jx.data"
                    :key="i"
                  >
                    <p
                      class="works_tt _width text_c"
                      style="display: flex;align-items: center;justify-content: center;height: .55rem;line-height: .55rem;font-size: .3rem;"
                    >{{ item_m.title }}
                      <span
                        class="pic-type"
                        v-if="item_m.opusType == '2'"
                      >（组图）</span>
                      <span
                        class="pic-type"
                        v-if="item_m.opusType == '1'"
                      >（单幅）</span>
                    </p>
                    <!-- 作者 -->
                    <p class="name _width text_c">{{ item_m.author }}</p>

                    <!-- 作品简介 -->
                    <div
                      class="works_dosc_mobile _width fl"
                      v-if="item_m.activityPublicitySubs.length > 1"
                    >
                      {{ item_m.introduce }}
                    </div>
                    <!-- 作品简介 end -->
                    <!-- 作品banner -->
                    <div class="mobile_conter _width fl">
                      <!-- 多图的时候 -->
                      <ul
                        class="mobile_cover _width"
                        v-if="item_m.activityPublicitySubs.length > 1"
                      >
                        <li
                          v-for="(
                            item_s, index_s
                          ) in item_m.activityPublicitySubs"
                          :key="index_s"
                        >
                          <img
                            class="swiper-image"
                            v-lazy="item_s.url"
                            alt=""
                          />
                          <p class="one_title _width">{{ item_s.introduce }}</p>
                        </li>
                      </ul>
                      <!-- 单张的时候 -->
                      <ul
                        class="mobile_cover _width"
                        v-if="item_m.activityPublicitySubs.length == 1"
                      >
                        <li>
                          <img
                            class="swiper-image"
                            v-lazy="item_m.activityPublicitySubs[0].url"
                            alt=""
                          />
                        </li>
                      </ul>
                      <p
                        class="one_title _width"
                        v-if="item_m.activityPublicitySubs.length == 1"
                      >
                        {{ item_m.introduce }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- 移动端获奖作品 end-->

                <!-- pc 端获奖作品-->
                <div
                  class="winning _width"
                  v-for="(item_jx, index_jx) in Publicity"
                  :key="index_jx"
                  :class="{'add-height':index_jx == 0}"
                >
                  <!-- pc端 获奖公示 -->
                  <!--  获奖icon -->
                  <div
                    class="winning_icon _width"
                    v-if="item_jx.prizeName"
                  >
                    <div class="winning_icon_img">
                      <img
                        src="@/assets/image/avtivity_details/winning.png"
                        alt=""
                      />
                      <p>{{ item_jx.prizeName }}</p>
                    </div>
                  </div>
                  <div
                    class="winning_works _width winning_works_pc"
                    v-for="(it, i_pc) in item_jx.data"
                    :key="i_pc"
                  >
                    <p
                      class="works_tt _width text_c"
                      style="display: flex;align-items: center;justify-content: center;height: 55px;line-height: 55px;font-size: .3rem;"
                    >{{ it.title }}
                      <span
                        class="pic-type"
                        v-if="it.activityPublicitySubs.length > 1"
                      >（组图）</span>
                      <span
                        class="pic-type"
                        v-if="it.activityPublicitySubs.length == 1"
                      >（单幅）</span>
                    </p>
                    <p class="name _width text_c">{{ it.author }}</p>
                    <!-- 作品banner -->

                    <!-- 多张的时候 -->
                    <div
                      class="works_cover_banner _width"
                      v-if="it.activityPublicitySubs.length > 1"
                    >
                      <div class="swiper-box">
                        <activity_details :childData="it"></activity_details>
                      </div>
                    </div>

                    <!-- 单张的时候 -->
                    <div
                      class="works_cover_banner _width"
                      v-if="it.activityPublicitySubs.length == 1"
                    >
                      <div class="swiper-box dan">
                        <img
                          v-lazy="it.activityPublicitySubs[0].url"
                          alt=""
                          class="one_img _width"
                        />
                      </div>
                    </div>

                    <!-- 作品切换 -->

                    <!-- 作品简介 -->
                    <div class="works_dosc _width">
                      {{ it.introduce }}
                    </div>
                    <!-- 作品简介 end -->
                  </div>
                  <!-- pc 端获奖作品 end-->
                </div>
              </div>
              <!-- 1轮播图模式 end-->

              <!-- 2平铺模式 -->
              <div v-if="
                  !loading_bool &&
                  Publicity &&
                  this.details_son.publicityTemplate == 2
                ">
                <!-- 奖项分类 -->
                <div
                  class="_width tab_prize"
                  id="tab_prize"
                  :class="goTopShow == true ? 'position_flex' : ''"
                >
                  <div class="_width tab_prize_position">
                    <ul class="_width tab_prize">
                      <li
                        v-for="(item_prize, key_prize) in Publicity"
                        @click="tab_prize_click('block' + key_prize, key_prize)"
                        :class="{ active_ref: active_prize == key_prize }"
                        :key="key_prize"
                      >
                        {{ item_prize.prizeName }}
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 奖项分类 end-->

                <!-- 公示简介 -->
                <div
                  class="introduction"
                  v-if="details_son.publicityContent"
                  v-html="details_son.publicityContent"
                ></div>
                <!-- 公示简介 end-->

                <!-- 移动端获奖作品 -->
                <div
                  class="_width fl anmition_show"
                  v-for="(item_jx, index_jx) in Publicity"
                  :key="index_jx"
                  :class="{'add-height':index_jx == 0}"
                >
                  <!-- 获奖icon   -->
                  <div
                    class="winning_icon _width"
                    :id="'id' + index_jx"
                    :ref="'block' + index_jx"
                    v-if="item_jx.prizeName"
                  >
                    <div class="winning_icon_img">
                      <img
                        src="@/assets/image/avtivity_details/winning.png"
                        alt=""
                      />
                      <p>{{ item_jx.prizeName }}</p>
                    </div>
                  </div>

                  <div
                    class="winning_works _width winning_works_mobile"
                    v-for="(item_m, i) in item_jx.data"
                    :key="i"
                  >
                    <p
                      class="works_tt _width text_c"
                      style="display: flex;align-items: center;justify-content: center;height: .55rem;line-height: .55rem;font-size: .3rem;"
                    >{{ item_m.title }}
                      <span
                        class="pic-type"
                        v-if="item_m.opusType == '2'"
                      >（组图）</span>
                      <span
                        class="pic-type"
                        v-if="item_m.opusType == '1'"
                      >（单幅）</span>
                    </p>
                    <!-- 作者 -->
                    <p class="name _width text_c">{{ item_m.author }}</p>

                    <!-- 作品简介 -->
                    <div class="works_dosc_mobile _width fl">
                      {{ item_m.introduce }}
                    </div>
                    <!-- 作品简介 end -->
                    <!-- 作品banner -->
                    <div class="mobile_conter _width fl">
                      <ul class="mobile_cover _width">
                        <li
                          v-for="(
                            item_s, index_s
                          ) in item_m.activityPublicitySubs"
                          :key="index_s"
                        >
                          <div
                            class="img_conter fl"
                            :title="item_m.title"
                          >
                            <img
                              class="swiper-image fade_image_out anmition_show"
                              v-lazy="item_s.url"
                              alt=""
                            />
                          </div>
                          <p class="one_title _width">{{ item_s.introduce }}</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- 移动端获奖作品 end-->
              </div>
              <!-- 2平铺模式 end-->

              <!-- 暂无数据 -->
              <ul
                class="comments"
                v-if="!Publicity"
              >
                <div class="null_data">
                  <img
                    src="@/assets/image/common/null_data.png"
                    alt=""
                  />
                  <p>暂无公示...</p>
                </div>
              </ul>
              <!-- 暂无数据 -->
            </div>
          </li>

          <div
            v-if="activityId !== 'd084456319e24d7e85ee15e668e04678'"
            class="_width"
          >
            <!-- 全部作品 -->
            <li v-if="
                details.activityStatus !== 1 &&
                works_list &&
                activeIndex == '全部作品'
              ">
              <!-- 全部作品  列表 -->
              <div class="pad _width">
                <!-- 公示简介 end -->
                <!-- 活动筛选 -->
                <div
                  class="classification _width"
                  v-if="works_list.length > 0"
                >
                  <p
                    :class="cur == 1 ? 'active_style' : ''"
                    @click="on_style(1)"
                  >
                    全部
                  </p>
                  <p
                    :class="cur == 2 ? 'active_style' : ''"
                    @click="on_style(2)"
                  >
                    热门
                  </p>
                </div>
                <!-- 活动筛选 end-->

                <Loading :loading_bool="loading_bool"></Loading>

                <div
                  class="classification_list_wrap"
                  v-if="!loading_bool"
                >
                  <ul
                    class="classification_list _width"
                    v-if="works_list.length !== 0"
                  >
                    <li
                      v-for="(item, index1) in works_list"
                      :key="index1"
                      class="fl anmition_show"
                    >
                      <div class="li_son _width fl">
                        <div
                          class="cover_div _width fl"
                          @click="
                            on_details(
                              item.activityId,
                              item.fullname,
                              item.type,
                              item.workId,
                              item.authorId
                            )
                          "
                        >
                          <div class="cover_s">
                            <div class="error_img">
                              <div class="error_img_conter">
                                <img
                                  :src="error_login"
                                  alt=""
                                />
                              </div>
                            </div>

                            <img
                              :src="item.opusCover | filterFun_sss"
                              alt="item.title"
                              :onerror="defaultImg"
                              class="cover_img fade_image_out"
                            />
                          </div>

                          <!-- 封面icon -->
                          <span
                            class="img_icon"
                            v-if="item.workNum !== 0"
                          >
                            {{ item.workNum }}
                          </span>
                          <!-- 封面icon end -->
                        </div>
                        <div class="_width cover_bottom fl">
                          <p
                            class="title_tag _width"
                            @click="
                              on_details(
                                item.activityId,
                                item.fullname,
                                item.type,
                                item.workId,
                                item.authorId
                              )
                            "
                          >
                            {{ item.opusName }}
                          </p>

                          <!-- 用户信息 -->
                          <div class="user _width">
                            <div
                              class="left"
                              @click="
                                on_details(
                                  item.activityId,
                                  item.fullname,
                                  item.type,
                                  item.workId,
                                  item.authorId
                                )
                              "
                            >
                              <img
                                src="@/assets/image/common/nan.png"
                                alt="item.title"
                                v-if="item.headimg == ''"
                              />
                              <img
                                :src="item.headimg"
                                v-else
                                alt=""
                              />
                              <p class="name">{{ item.fullname }}</p>
                            </div>
                            <!-- v-if="details_son.isWebVote ==0 && details_son.isEndVote == 1 " -->
                            <span>{{ item.workVoke }}</span>
                          </div>
                          <!-- 用户信息 end-->

                          <!-- 投票 -->
                          <div
                            class="_width"
                            v-if="
                              details_son.isWebVote == 1 &&
                              details_son.isEndVote == 0
                            "
                          >
                            <!-- 已经投票 -->
                            <div
                              class="_width already-follow-wrap no mobile"
                              v-if="item.isVote == 0"
                            >
                              <div
                                class="tp _width already-follow-icon-box"
                                v-ripple="'rgba(255, 255, 255, 0.45)'"
                              >
                                已投票
                              </div>
                              <div
                                class="tp _width unfollow-icon-box"
                                @click="vote(index1, item.workId)"
                                v-ripple="'rgba(255, 255, 255, 0.45)'"
                              >
                                取消投票
                              </div>
                            </div>

                            <!-- 未投票 -->
                            <div
                              class="_width already-follow-wrap mobile"
                              v-if="item.isVote != 0"
                            >
                              <div
                                class="tp _width yes"
                                @click="vote(index1, item.workId)"
                                v-ripple="'rgba(255, 255, 255, 0.45)'"
                              >
                                为TA投票
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>

                  <!-- 暂无数据 -->
                  <div
                    class="null_data _width"
                    v-if="works_list == 0"
                  >
                    <img
                      src="@/assets/image/common/null_data.png"
                      alt=""
                    />
                    <p>暂无公布作品...</p>
                  </div>
                  <!-- 暂无数据 -->
                </div>

                <div class="_width page_data card_body">
                  <el-pagination
                    background
                    :hide-on-single-page="true"
                    layout="prev, pager, next"
                    :page-sizes="[2, 4, 6, 8]"
                    :current-page="page.current_page"
                    @current-change="handleCurrentChange"
                    :page-size="page.PageSize"
                    :total="page.total"
                  ></el-pagination>
                </div>
              </div>
            </li>
            <!-- 活动简介 -->
            <li
              v-if="this.activeIndex == '活动简介'"
              class="bag"
            >
              <div
                v-html="details_son.comments"
                class="comments anmition_show"
                v-if="details_son.comments"
              ></div>

              <!-- 暂无数据 -->
              <ul
                class="comments"
                v-else
              >
                <div class="null_data">
                  <img
                    src="@/assets/image/common/null_data.png"
                    alt=""
                  />
                  <p>暂无简介...</p>
                </div>
              </ul>
              <!-- 暂无数据 -->
            </li>
          </div>
        </ul>
      </div>
      <!-- 居中 end-->
      <!-- 返回顶部 -->
      <div
        class="go_top"
        v-show="goTopShow"
        @click="goTop"
        @mouseenter="over_go_top = 1"
        @mouseleave="over_go_top = 0"
      >
        <div>
          <img
            src="@/assets/image/common/gotop1.png"
            alt=""
          />
          <img
            src="@/assets/image/common/gotop2.png"
            alt=""
            class="hide_gotop"
            :class="over_go_top == 1 ? 'show_gotop' : ''"
          />
        </div>
      </div>
    </div>
    <!-- conter end -->
    <!-- footer -->
    <Footer></Footer>
    <!-- footer end-->
  </div>
</template>

<script>
import Loading from "@/components/loading/loading.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";

import activity_details from "@/components/swiper/activityDetailsSwiper.vue";
import {
  avtivity_details,
  WorkList,
  WorkPublicity,
  playVote,
  follow,
  is_follow,
  workClick,
} from "@/utils/api/activity.js";
import { Info } from "@/utils/api/login.js";
import { socialShare } from "@/modules/common.js";
import { web_title } from "@/modules/title.js"; //

export default {
  data () {
    return {
      // publicityTemplate: 2,//判断是什么方式展示
      scrollTop: "",
      over_go_top: 0, //返回顶部  显示
      goTopShow: false, // 返回顶部

      active_prize: 0, // 当前奖项高亮
      listBoxState: true, //点击导航栏时，暂时停止监听页面滚动

      textTitle: "", //页面标题
      loading_bool: true, //加载loading
      activeIndex: "", //默认 全部作品  tabi切换
      is_follow: "", // 关注
      tabList: [
        {
          name: "获奖公示",
        },
        {
          name: "全部作品",
        },
        {
          name: "活动简介",
        },
      ],

      gs_show: false, //公示显示
      zp_show: true, //作品列表
      hd_show: true, //活动简介

      details: [], //详情
      details_son: {}, //详情下的数据
      Publicity: [], //活动公示
      works_list: [], //作品数据
      // 全部作品筛选
      cur: 1, //0.全部  1.热门
      // 作品分页
      page: {
        total: 0, //总数
        current_page: 1, //默认第一页
        PageSize: 20, //每页条数
      },
      value: "",

      share: {}, //分享数据
      shareicon: 0, //分享iccon
      url: "", // 分享的地址  二维码地址
      Login: {}, //登录后信息
      defaultImg:
        'this.src="' + require("@/assets/image/common/loading.gif") + '"', //未加载
      error_login: require("@/assets/image/common/loading.gif"),
      isLogin_user: {}, //登录后的信息

      jin: [], //金奖
    };
  },
  computed: {},
  watch: {
    scrollTop (val) {
      if (this.scrollTop > 552) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
  },
  filters: {
    filterFun_as: function (value) {
      return value.replace(".jpg", "_as.jpg"); //最大
    },
    filterFun_ss: function (value) {
      return value
        .replace(".jpg", "_activity_s.jpg")
        .replace(".png", "_activity_s.png"); //最大
    },

    filterFun_sss: function (value) {
      return value.replace(".jpg", "_sss.jpg"); //最小
    },
  },
  created () {
    this.is_login(); //是否登陆
    window.scrollTo(0, 0);
    this.activityId = this.$route.params && this.$route.params.id;
    this.router_url = this.$route.fullPath; //当前地址url
    let params = {
      activityId: this.activityId,
      current: 1,
      size: this.page.PageSize,
      type: this.cur,
    };
    let params_details = {
      activityId: this.activityId,
    };
    this.avtivity_details_data(params_details); //详情数据
    this.WorkPublicity_data(params_details); //活动公示
    // this.Follow(params);//关注
    this.WorkList_data(params); //作品列表
    this.is_follow_data(params_details); //判断是否登录
  },
  mounted () {
    // console.log(window.screen.width, '屏幕大小')
    this.$nextTick(() => {
      this.showQRCodes(); //生成二维码
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 记录滚动
    handleScroll () {
      // 获取视窗高度
      let domHight = document.body.offsetHeight;
      // dom滚动位置
      let scrollTop = (this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop);

      // let heightStyle1 = this.$refs.banner_wp.offsetHeight; //banenr 距离顶部
      let heightStyle1 = document.querySelector("#banner_wp").offsetHeight; //banenr 距离顶部

      //奖项点击 导航高度
      // let offsetTop = document.querySelector("#tab_prize").offsetHeight;

      if (scrollTop >= heightStyle1) {
        this.goTopShow = true;
      }
      // 当在顶部的时候 默认第一个
      if (this.goTopShow == false) {
        this.active_prize = 0;
        // console.log('到顶了');
      }
      // 当奖项切换导航为悬浮时，开启记录位置高亮状态
      if (this.goTopShow == true) {
        this.Publicity.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(`id${i}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(`id${0}`).scrollHeight;
          // console.log('滚动了', scrollTop);
          // console.log('距离顶部', offsetTop);
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            //   // 导航栏背景色选中
            this.active_prize = i;
            // console.log('到了');
          }
        });
      }
    },
    // 点击返回顶部
    goTop () {
      let timer = null,
        _that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn () {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 250;
          document.body.scrollTop = document.documentElement.scrollTop =
            _that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _that.goTopShow = false;
        }
      });
    },

    // 定位奖项位置
    tab_prize_click (index, id) {
      this.active_prize = id; //点击的高亮

      this.$el.querySelector(`#id${id}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        // block: "start"  // 上边框与视窗顶部平齐。默认值
        block: "center",
      });
      this.listBoxState = false;

      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },

    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin;
        if (this.isLogin == true) {
          this.isLogin_user = data.user;
        }
      });
    },
    // 生成为二维码
    showQRCodes () {
      setTimeout(() => {
        this.url = "https://v.jingjiribao.cn/newcommunity/#" + this.router_url;
        let qrcode = new this.$QRCode("qrcodes", {
          text: this.url, //当前地址栏完整参数
          width: 140,
          height: 140,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: this.$QRCode.CorrectLevel.H,
        });
      }, 1000);
    },

    //  分享到qq
    share_qq () {
      const share = {
        title: "中经视觉-" + this.details_son.title,
        desc: this.details_son.title,
        share_url: window.location.href,
      };
      window.open(
        "https://connect.qq.com/widget/shareqq/index.html?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&desc=" +
        share.desc
      );
    },
    //  分享到qq空间
    share_qz () {
      const share = {
        title: "中经视觉-" + this.details_son.title,
        desc: this.details_son.title,
        share_url: window.location.href,
        image_url: this.details_son.activityUrl,
      };
      window.open(
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
        encodeURIComponent(share.share_url) +
        "&site=掌上理工大&title=" +
        share.title +
        "&pics=" +
        share.image_url +
        "&summary=" +
        share.desc
      );
    },
    //  分享到微博
    share_wb () {
      const share = {
        title: "中经视觉-" + this.details_son.title,
        desc: this.details_son.title,
        share_url: window.location.href,
        image_url: this.details_son.activityUrl,
      };
      window.open(
        "https://service.weibo.com/share/share.php?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&pic=" +
        share.image_url +
        "&searchPic=true"
      );
    },

    // 判断系统 下载
    openapp () {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        // alert("我是安卓");
        window.open(
          "https://appgallery.huawei.com/#/app/C10900136?sharePrepath=ag&locale=zh_CN&source=appshare&subsource=C10900136&shareTo=weixin&shareFrom=appmarket"
        );
        //
        this.android();
      }
      if (isIOS) {
        // alert("我是苹果");
        window.open(
          "https://apps.apple.com/cn/app/%E4%B8%AD%E7%BB%8F%E8%A7%86%E8%A7%89/id1190222970"
        );
      }
    },

    // 分享
    getSocialShareUrls () {
      let title_url = this.details_son.title + window.location.href;
      let info = {
        url: title_url,
        title: "中经视觉-" + this.details_son.title,
        title: this.details_son.title,
        desc: window.location.href, //描述
        image: this.details_son.activityUrl, //图片
        summary: window.location.href, //简介
      };
      ["qq", "wx", "wb", "kj"].forEach((v) => {
        this.share[v] = socialShare(v, info);
      });
    },

    // 判断是否关注
    is_follow_data (params) {
      is_follow(params).then((res) => {
        let data = res.data;
        this.is_follow = data.exist;
      });
    },

    // 关注
    follow () {
      // 未登录就去登录
      if (this.isLogin == true) {
        let params = {
          activityId: this.activityId,
        };
        follow(params).then((res) => {
          let data = res.data;
          if (data.msg == "关注成功") {
            this.is_follow = true;
            this.$notify({
              title: data.msg,
              type: "success",
            });
            return false;
          }
          if (data.msg == "取消关注") {
            this.is_follow = false;
            this.$notify({
              title: "取消关注成功",
              // message: '这是一条成功的提示消息',
              type: "success",
            });
            return false;
          } else if (data.status == 403) {
            this.$message.error(data.msg);
            return false;
            // this.$router.push(
            //   {
            //     path: '/login/?type=' + 1,
            //   }
            // )
          }
        });
      } else {
        sessionStorage.setItem("router_url", this.router_url); //活动详情
        this.$router.push({
          path: "/login/?state=" + 1,
        });
      }
    },
    // 点击报名参赛
    on_click_go (id, title, on_click_go) {
      this.is_login();
      // 未登录就去登录
      if (this.isLogin == true) {
        if (on_click_go.opusType == 2) {
          // 登录后就去报名
          this.url = "https://v.jingjiribao.cn/manu/manuEntry?activeId=";
          window.location.href =
            this.url + id + "&activeName=" + title + "&picType=" + 4;
        } else {
          // 登录后就去报名
          this.url = "https://v.jingjiribao.cn/manu/manuEntry?activeId=";
          window.location.href = this.url + id + "&activeName=" + title;
        }
      } else {
        sessionStorage.setItem("router_url", this.router_url); //活动详情
        this.$router.push({
          path: "/login/?state=" + 1,
        });
      }
    },

    // tab切换
    tabChange (name) {
      // if (this.isLogin == true) {
      this.activeIndex = name;
      var activeTit = this.activeIndex;
      if (this.activeIndex == "活动简介") {
        activeTit = "活动通知";
      } else if (this.activeIndex == "全部作品") {
        activeTit = "优秀作品";
      }
      document.title = "中经视觉-" + this.details_son.title + "-" + activeTit;
      // } else {
      //   sessionStorage.setItem('activity_details', this.router_url)//活动详情
      //   this.$router.push(
      //     {
      //       path: '/login/?state=' + 1,
      //     }
      //   )
      // }
    },

    // 进入作品详情
    on_details (activityId, fullname, type, workId, authorId) {
      var workClickData = {
        type: type, // 2 组图   1 单图
        activityId: activityId,
        workId: workId,
      };
      // 点击活动调用接口记录浏览量
      workClick(workClickData).then((res) => {
        let data = res.data;
        if (data.code == 200) {
          if (type == 1) {
            //  组图
            this.$router.push({
              path: "/workDeatils_type1",
              query: {
                activityId: activityId,
                fullname: fullname,
                type: type,
                workId: workId,
                authorId: authorId,
                isWebVote: this.details_son.isWebVote,
                isEndVote: this.details_son.isEndVote,
              },
            });
          } else if (type == 2) {
            //  单图
            this.$router.push({
              path: "/workDeatils_type2",
              query: {
                activityId: activityId,
                fullname: fullname,
                type: type,
                workId: workId,
                authorId: authorId,
                isWebVote: this.details_son.isWebVote,
                isEndVote: this.details_son.isEndVote,
              },
            });
          }
        } else {
          this.$message.error(data.message);
        }
        // this.loading_bool = false
      });
    },
    // 点击投票 取消投票
    vote (index, workId) {
      this.is_login();

      // 未登录就去登录
      if (this.isLogin == true) {
        let params_details = {
          activityId: this.activityId,
          workId: workId,
          type: this.cur,
        };
        this.playVote_data(params_details);
      } else {
        sessionStorage.setItem("router_url", this.router_url); //活动详情
        this.$router.push({
          path: "/login/?state=" + 1,
        });
      }
    },

    //投票数据
    playVote_data (params_details) {
      playVote(params_details).then((res) => {
        // this.loading_bool = true;
        let data = res.data;
        // this.Publicity = data;
        // console.log(this.Publicity);
        if (data.code == 200) {
          // 成功后刷新列表
          let params = {
            activityId: this.activityId,
            current: this.page.current_page,
            size: this.page.PageSize,
            type: this.cur,
          };
          this.WorkList_data(params); //作品列表
        } else {
          this.$message.error(data.message);
        }
        // this.loading_bool = false
      });
    },

    // 活动详情
    avtivity_details_data (params) {
      this.loading_bool = true;
      avtivity_details(params).then((res) => {
        let data = res.data;
        this.details = data;
        // 设置tab默认选中
        // console.log(this.details);
        if (this.details.status == 200) {
          data.activity.dealOpenTime =
            data.activity.openTimeString.split(" ")[0];
          data.activity.dealEndTime = data.activity.endTimeString.split(" ")[0];
          this.details_son = data.activity;

          if (this.activityId == "d084456319e24d7e85ee15e668e04678") {
            this.gs_show = true; //显示公示 获奖公示
            this.activeIndex = "获奖公示";
          } else {
            // 进行中 activityStatus：1 活动未开始
            if (this.details_son.activityStatus == 1) {
              this.zp_show = false; //显示作品
              this.hd_show = true; //活动简介
              this.activeIndex = "活动简介";
            }

            // 进行中 activityStatus：2 活动进行中
            if (
              this.details_son.activityStatus == 2 &&
              this.works_list.length !== 0
            ) {
              this.zp_show = true; //显示作品
              this.hd_show = true; //活动简介
              this.activeIndex = "全部作品";
            } else if (
              this.details_son.activityStatus == 2 &&
              this.works_list.length == 0
            ) {
              this.zp_show = true; //显示作品
              this.hd_show = true; //活动简介
              this.activeIndex = "活动简介";
            }

            // 活动已结束  判断公示 已经公示 publicityStatus：0未公示  1公示
            if (
              this.details_son.publicityStatus == 1 &&
              this.works_list.length !== 0
            ) {
              this.gs_show = true; //显示公示 获奖公示
              this.hd_show = true; //活动简介
              this.zp_show = true; //显示作品
              this.activeIndex = "获奖公示";
            } else if (
              this.details_son.publicityStatus == 1 &&
              this.works_list.length == 0
            ) {
              this.gs_show = true; //显示公示 获奖公示
              this.hd_show = true; //活动简介
              this.activeIndex = "获奖公示";
            }
            // 判断公示 没有公示
            if (
              this.details_son.publicityStatus != 1 &&
              this.works_list.length !== 0
            ) {
              this.hd_show = true; //活动简介
              this.zp_show = true; //显示作品
              this.activeIndex = "全部作品";
            } else if (
              this.details_son.publicityStatus != 1 &&
              this.works_list.length == 0
            ) {
              this.hd_show = true; //活动简介
              this.zp_show = true; //显示作品
              this.activeIndex = "活动简介";
            }
            this.getSocialShareUrls(); //分享详情
            this.loading_bool = false;
          }
          var activeTit = this.activeIndex;
          if (this.activeIndex == "活动简介") {
            activeTit = "活动通知";
          } else if (this.activeIndex == "全部作品") {
            activeTit = "优秀作品";
          }
          document.title =
            "中经视觉-" + this.details_son.title + "-" + activeTit;
          if (this.details.status !== 200) {
            this.$message.error(this.details.msg);
          }
        }
      });
    },

    //活动公示
    WorkPublicity_data (params_details) {
      this.loading_bool = true;
      WorkPublicity(params_details).then((res) => {
        let data = res.data;
        // this.Publicity = data.data;
        let Publicity = data.data;
        // this.Publicity.map((item) => {
        //   if (item.prizeName == '金奖') {
        //     this.jin = item
        //     console.log(this.jin);
        //   } else if (item.prizeName == '银奖') {
        //     this.yin = item
        //     console.log(this.yin);
        //   } else {
        //     this.tong = item
        //     console.log(this.tong);
        //   }
        // })
        let map = {};
        for (let i = 0; i < Publicity.length; i++) {
          let data_list = Publicity[i];
          if (!map[data_list.prizeName]) {
            map[data_list.prizeName] = [data_list];
          } else {
            map[data_list.prizeName].push(data_list);
          }
        }
        let new_res = [];
        Object.keys(map).forEach((key) => {
          new_res.push({
            prizeName: key,
            data: map[key],
          });
        });
        this.Publicity = new_res;
        // console.log(this.Publicity);
        this.loading_bool = false;
      });
    },

    // 作品列表
    WorkList_data (params) {
      this.loading_bool = true;
      WorkList(params).then((res) => {
        let data = res.data;
        this.works_list = data.data.records;
        this.page.total = data.data.total; //全部数据
        this.page.current_page = data.data.current; //默认第一页
        this.page.PageSize = data.data.size; //每页条数
        this.loading_bool = false;
      });
    },
    //作品 筛选
    on_style (index) {
      this.cur = index;
      let params = {
        activityId: this.activityId,
        current: 1,
        size: this.page.PageSize,
        type: this.cur,
      };
      this.WorkList_data(params); //作品列表
    },

    //作品 点击分页
    handleCurrentChange (val) {
      console.log(val);
      let params = {
        activityId: this.activityId,
        current: val,
        size: this.page.PageSize,
        type: this.cur,
      };
      this.WorkList_data(params);
      window.scrollTo(0, 505);
    },
  },

  components: {
    socialShare,
    activity_details,
    Loading,
    Header,
    Footer,
  },
};
</script>

<style scoped>
@import "../../assets/css/activity/activity_details.css";
.home >>> .header_center .navList li:nth-child(7) a {
  color: #c00 !important;
}
.dan img {
  width: 100%;
  height: 100%;
  float: left;
  object-fit: cover;
}

.works_cover_banner >>> .swiper-pagination-bullet-active {
  opacity: 1;
  background: #c00;
}

img[lazy="loading"] {
  display: block;
  width: 0.5rem !important;
  height: 0.5rem !important;
  margin: 30% 50%;
  /* border: 1px solid red; */
}
.pic-type {
  font-size: 0.16rem;
  color: #8e8e8e;
}
.add-height {
  margin-top: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/activity/activity_details.vue